export default [
  {
    title: "Anpassad dimension",
    key: "CUSTOM_DIMENSION",
    visited: true,
    hasError: false,
    fieldKeys: ["title", "dimension_id"],
  },
  {
    title: "Bekräfta",
    key: "CONFIRM",
    visited: false,
    hasError: false,
    fieldKeys: [],
  },
];
